export const csaFeedbackBeginSelectionEventType = 'csaFeedbackBeginSelectionEvent';
export const csaFeedbackEndSelectionEventType = 'csaFeedbackEndSelectionEvent';
/**
 * This event is fired when the user intiates/stops point-and-click mode for selecting a
 * faulty component.
 */
export const makeCSAFeedbackBeginSelectionEvent = (detail) => {
    return new CustomEvent(csaFeedbackBeginSelectionEventType, {
        detail,
    });
};
export const makeCSAFeedbackEndSelectionEvent = (detail) => {
    return new CustomEvent(csaFeedbackEndSelectionEventType, {
        detail,
    });
};
export const csaFeedbackCandidateNominatedEventType = 'csaFeedbackCandidateNominatedEvent';
/**
 * This event is fired when tool is in CSA Feedback collection mode and the
 * user selects a candidate faulty component to be reported.
 */
export const makeCSAFeedbackCandidateNominatedEvent = (detail) => {
    return new CustomEvent(csaFeedbackCandidateNominatedEventType, {
        detail,
    });
};
export const csaFeedbackCandidateDismissedEventType = 'csaFeedbackCandidateDismissedEvent';
/**
 * This event is fired when tool is in CSA Feedback collection mode and the
 * user dismisses previously nominated candidate to be reported.
 */
export const makeCSAFeedbackCandidateDismissedEvent = (detail) => {
    return new CustomEvent(csaFeedbackCandidateDismissedEventType, {
        detail,
    });
};
export const errorReportedEventType = "ErrorReportedEvent";
//# sourceMappingURL=CSAFeedbackSelectTargetEvent.js.map